<template>
  <div class="users-count-circle unselectable background-post-tint color-post-background rounded-circle" :class="{ small, tiny }">{{ countComputed }}</div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    tiny: {
      type: Boolean,
      default: false
    },
    maxCount: {
      type: Number,
      default: null
    }
  },
  computed: {
    countComputed() {
      if (this.maxCount && this.count >= this.maxCount) {
        return `${this.maxCount}+`
      }
      return this.count
    }
  }
}
</script>

<style lang="scss">
.users-count-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 88px;
  min-height: 88px;
  max-height: 88px;
  font-weight: bold;
  font-size: var(--font-size-title-huge);

  &.small {
    min-width: 48px;
    min-height: 48px;
    max-height: 48px;
    font-size: var(--font-size-title);
  }

  &.tiny {
    min-width: 20px;
    min-height: 20px;
    max-height: 20px;
    font-size: var(--font-size-x-small);
  }
}
</style>
